class CustomCarousel extends HTMLElement {
  constructor() {
    super();
    this.product_page_root = this.closest("main-product");
    this.animating = false;
    this.pos_x = 0;
    this.pos_x_initial = 0;
    this.pos_x_difference = 0;
    this.threshold = 100;
    this.carousel_container = this.querySelector(".carousel");
    this.root = this.closest(".carousel-root");
    if (this.root) {
      this.thumbnail_controller = this.root.querySelector(
        ".carousel__thumbnails"
      );
      if (this.thumbnail_controller) {
        this.thumbnail_inner =
          this.thumbnail_controller.querySelector(".carousel__inner");
        this.thumbnails_in_view =
          this.thumbnail_inner.dataset.showThumbnails * 1;
        this.thumbnail_wrap = this.thumbnail_controller.querySelector(
          ".carousel__thumbnails > div"
        );
        this.thumbnail_container =
          this.thumbnail_controller.querySelector(".carousel__inner");
        this.thumbnail_prev_button = this.root.querySelector(
          ".carousel__button--prev"
        );
        this.thumbnail_next_button = this.root.querySelector(
          ".carousel__button--next"
        );
        this.clone_thumb = this.thumbnail_controller
          .querySelector(".carousel__item:first-child")
          .cloneNode(true);
        this.clone_thumb.querySelector("img").srcset = "";
      }
    }
    this.carousel = this.carousel_container.querySelector(".carousel__inner");
    this.carousel_width = this.carousel.offsetWidth;
    this.clone = this.carousel
      .querySelector(".carousel__item:first-child")
      .cloneNode(true);
    if (this.clone.querySelector("img")) {
      this.clone.querySelector("img").srcset = "";
    }
    this.animation_speed = this.carousel.dataset.animationSpeed * 1 || 400;
    this.auto_animate = this.carousel.dataset.auto === "true";
    this.slides_in_view = this.carousel.dataset.slidesView * 1 || 1;
    this.fixed_width = this.carousel.dataset.fixedWidth === "true";
    this.shift = 0;
    this.slide_dimension_value = 364;
    this.carousel_prev = this.querySelector(".carousel__button--prev");
    this.carousel_next = this.querySelector(".carousel__button--next");
    this.header_banner = document.querySelector(".header-banner");
    this.load();
    if (this.carousel_container.offsetWidth >= this.carousel.offsetWidth) {
      this.carousel_prev.style.display = "none";
      this.carousel_next.style.display = "none";
      this.carousel.classList.add("justify-center");
    }
  }

  load() {
    this.initSlider();
    if (!this.fixed_width) {
      this.slide_dimension_value = this.slides[0].offsetWidth;
    }
    this.addPageListeners();
  }

  initSlider() {
    this.carousel_container = this.querySelector(".carousel");
    this.carousel = this.carousel_container.querySelector(".carousel__inner");
    this.slides = Array.from(this.carousel.querySelectorAll(".carousel__item"));
    if (this.thumbnail_controller) {
      this.thumbnails = Array.from(
        this.thumbnail_controller.querySelectorAll(".carousel__item")
      );
      this.thumbnail_counter = 0;
      this.thumbnail_container.children[this.thumbnail_counter].classList.add(
        "active"
      );
    }
    this.counter = 1;
    this.slides.forEach((slide, index) => {
      slide.classList.remove("active");
      if (this.thumbnail_controller) {
        this.thumbnails[index] &&
          this.thumbnails[index].classList.remove("active");
      }
    });
    this.slides_number = this.slides.length;
    if (this.slides && this.slides[this.counter])
      this.slides[this.counter].classList.add("active");
    let slider_dimension;
    let slides_dimension;
    if (this.slides_number > 1) this.cloneSlides();
    if (this.fixed_width) {
      slider_dimension = this.slide_dimension_value * this.slides_number + "px";
      slides_dimension = this.slide_dimension_value + "px";
      for (let i = 1; i < this.slides_number; i++) {
        if (
          this.slides_in_view * this.slide_dimension_value <
          this.carousel_container.offsetWidth - this.slide_dimension_value
        ) {
          this.slides_in_view++;
        }
      }
    } else {
      slider_dimension = 100 * this.slides_number + "%";
      slides_dimension = 100 / this.slides_number / this.slides_in_view + "%";
    }
    this.initCarouselCss(slider_dimension, slides_dimension);
    this.addListeners();
    this.moveSlide();
    if (this.auto_animate) {
      this.animateAnnouncementBar();
    }
  }
  initCarouselCss(slider_dimension, slides_dimension) {
    this.carousel.style.width = slider_dimension;
    this.slides.map((slide) => {
      slide.style.width = slides_dimension;
    });
    if (this.thumbnail_controller) {
      this.current_thumbnail_page = 0;
      this.thumbnails_pages =
        Math.ceil((this.slides_number - 2) / this.thumbnails_in_view) - 1;
      this.container_size =
        this.thumbnail_wrap.offsetWidth * this.thumbnails_pages;
      if (this.thumbnails_pages > 0) {
        this.thumbnail_prev_button.style.display = "flex";
        this.thumbnail_prev_button.classList.add("disabled");
        this.thumbnail_next_button.classList.remove("disabled");
        this.thumbnail_next_button.style.display = "flex";
        this.thumbnail_inner.classList.remove("justify-center");
      } else {
        this.thumbnail_prev_button.style.display = "none";
        this.thumbnail_next_button.style.display = "none";
        this.thumbnail_inner.classList.add("justify-center");
      }
      this.thumbnail_container.style.transform = "translateX(0)";
    }
    this.carousel.style.transform = "translateX(0)";
    this.carousel_width =
      this.carousel_container.offsetWidth * this.slides_number;
    if (this.carousel_container.offsetWidth >= this.carousel_width) {
      this.carousel_prev.style.display = "none";
      this.carousel_next.style.display = "none";
    } else {
      this.carousel_prev.style.display = "flex";
      this.carousel_next.style.display = "flex";
    }
  }
  animateAnnouncementBar() {
    if (this.slides.length > 3) {
      setInterval(() => {
        this.carousel_next.click();
      }, 3000);
    } else {
      this.header_banner.style.display = "block";
      this.carousel_prev.style.display = "none";
      this.carousel_next.style.display = "none";
    }
  }
  moveContainer(page) {
    this.currentOffset = page * -this.thumbnail_wrap.offsetWidth;
    this.thumbnail_container.style.transform = `translateX(${this.currentOffset}px)`;
    if (this.thumbnails_pages === 0) {
      this.thumbnail_prev_button.classList.add("disabled");
      this.thumbnail_next_button.classList.add("disabled");
    } else if (
      this.currentOffset >= 0 ||
      (page === 0 && this.thumbnails_pages > 0)
    ) {
      this.thumbnail_prev_button.classList.add("disabled");
      this.thumbnail_next_button.classList.remove("disabled");
    } else if (
      this.currentOffset <=
      -(this.container_size - this.thumbnail_wrap.offsetWidth)
    ) {
      this.thumbnail_prev_button.classList.remove("disabled");
      this.thumbnail_next_button.classList.add("disabled");
    } else {
      this.thumbnail_prev_button.classList.remove("disabled");
      this.thumbnail_next_button.classList.remove("disabled");
    }
  }
  changePage(page) {
    this.current_thumbnail_page += page;
    if (this.current_thumbnail_page < 0) {
      this.moveContainer(this.thumbnails_pages);
    } else if (this.current_thumbnail_page > this.thumbnails_pages) {
      this.moveContainer(0);
    } else {
      this.moveContainer(this.current_thumbnail_page);
    }
  }

  removeListeners() {
    this.slides = this.carousel.querySelectorAll(".carousel__item");
    this.slides.forEach((slide) => {
      const new_element = slide.cloneNode(true);
      slide.parentNode.replaceChild(new_element, slide);
    });
    if (this.thumbnail_controller) {
      this.thumbnails =
        this.thumbnail_controller.querySelectorAll(".carousel__item");
      this.thumbnails.forEach((thumb) => {
        const new_element = thumb.cloneNode(true);
        thumb.parentNode.replaceChild(new_element, thumb);
      });
    }
  }
  addListeners() {
    this.slides.map((slide) => {
      slide.onmousedown = (e) => this.dragStart(e);
      slide.addEventListener("touchstart", this.dragStart.bind(this));
      slide.addEventListener("touchend", this.dragEnd.bind(this));
      slide.addEventListener("touchmove", this.dragAction.bind(this));
    });
    if (this.thumbnail_controller) {
      for (let i = 0; i < this.thumbnail_container.children.length; i++) {
        this.thumbnail_container.children[i].addEventListener("click", () => {
          this.changeSlide(i - this.counter + 1);
        });
      }
    }
  }

  addPageListeners() {
    this.carousel_prev.addEventListener("click", () => this.changeSlide(-1));
    this.carousel_next.addEventListener("click", () => this.changeSlide(1));
    if (this.thumbnail_controller) {
      this.thumbnail_prev_button.addEventListener("click", () =>
        this.changePage(-1)
      );
      this.thumbnail_next_button.addEventListener("click", () =>
        this.changePage(1)
      );
    }
    if (this.product_page_root) {
      this.product_page_root.addEventListener("media-change", (e) => {
        this.changeSrcSet(e.detail);
      });
    }
  }

  changeSrcSet(media) {
    let dom_numbers = this.slides_number - 2;
    const media_number = media.length;
    this.first_clone.remove();
    this.last_clone.remove();
    this.handleClonedElements(media_number, dom_numbers);
    this.carousel = this.carousel_container.querySelector(".carousel__inner");
    this.changeSlide(-this.counter, true);
    if (this.thumbnail_controller) {
      const thumbnail_images = Array.from(
        this.thumbnail_container.querySelectorAll("img")
      );
      this.changePage(-this.current_thumbnail_page);
      this.carousel.querySelectorAll("img").forEach((i, index) => {
        thumbnail_images[index].srcset = `${media[index]}&height=52`;
        i.srcset = media[index] + "&width=832";
      });
    } else {
      this.carousel.querySelectorAll("img").forEach((i, index) => {
        i.srcset = media[index] + "&width=832";
      });
    }
    this.removeListeners();
    this.initSlider();
  }
  handleClonedElements(media_number, dom_numbers) {
    if (media_number !== dom_numbers) {
      if (media_number > dom_numbers) {
        this.cloneMediaElements(media_number, dom_numbers);
      } else {
        for (let i = 0; i < dom_numbers - media_number; i++) {
          this.carousel.children[0].remove();
          if (this.thumbnail_controller) {
            this.thumbnail_container.children[0].remove();
          }
        }
      }
      this.slides_number = media_number;
    }
  }
  cloneMediaElements(media_number, dom_numbers) {
    for (let i = 0; i < media_number - dom_numbers; i++) {
      const clonedImgElement = this.clone.cloneNode(true);
      const clonedThumbnail = this.clone_thumb.cloneNode(true);
      this.carousel.insertBefore(
        clonedImgElement,
        this.carousel.lastElementChild
      );
      if (this.thumbnail_controller) {
        this.thumbnail_container.insertBefore(
          clonedThumbnail,
          this.thumbnail_container.lastElementChild
        );
      }
    }
  }

  cloneSlides() {
    this.first_clone = this.carousel
      .querySelector(".carousel__item:last-child")
      .cloneNode(true);
    this.last_clone = this.carousel
      .querySelector(".carousel__item:first-child")
      .cloneNode(true);
    this.carousel.insertBefore(
      this.first_clone,
      this.carousel.firstElementChild
    );
    this.carousel.insertBefore(
      this.last_clone,
      this.carousel.lastElementChild.nextSibling
    );
    this.slides = Array.from(this.carousel.querySelectorAll(".carousel__item"));
    this.slides_number = this.slides.length;
    this.shift = -((this.counter * 100) / this.slides_number).toFixed(2);
    this.carousel.style.transform = `translateX(${this.shift}%)`;
  }

  dragStart(e) {
    if (e.type === "mousedown") {
      e.preventDefault();
    }
    if (e.type === "touchstart") {
      this.pos_x = e.touches[0].clientX;
      this.pos_x_initial = e.touches[0].clientX;
    } else {
      this.pos_x = e.clientX;
      this.pos_x_initial = e.clientX;
      document.onmouseup = (ev) => this.dragEnd(ev);
      document.onmousemove = (ev) => this.dragAction(ev);
    }
  }

  dragAction(e) {
    e = e || window.event;

    if (e.type === "touchmove") {
      this.pos_x = e.touches[0].clientX;
    } else {
      this.pos_x = e.clientX;
    }
    this.pos_x_difference = this.pos_x_initial - this.pos_x;
    if (
      (this.counter === 0 && this.pos_x_difference < 0) ||
      (this.counter === this.slides_number - this.slides_in_view &&
        this.pos_x_difference > 0)
    ) {
      return;
    }
    if (!this.fixed_width) {
      this.carousel.style.transform = `translateX(calc(${this.shift}% - ${this.pos_x_difference}px))`;
    } else {
      this.carousel.style.transform = `translateX(${-(
        this.counter * this.slide_dimension_value +
        this.pos_x_difference
      )}px)`;
    }
  }

  dragEnd() {
    const slides_swiped = this.pos_x_difference / this.slide_dimension_value;
    if (this.pos_x_difference < -this.threshold) {
      this.changeSlide(Math.floor(slides_swiped));
    } else if (this.pos_x_difference > this.threshold) {
      this.changeSlide(Math.ceil(slides_swiped));
    } else {
      this.moveSlide();
    }
    this.pos_x_difference = 0;
    document.onmouseup = null;
    document.onmousemove = null;
  }
  changeSlide(direction, reset = false) {
    if (this.animating) {
      return;
    }
    this.initialiseConfig(direction, reset);
    this.moveSlide();
    setTimeout(() => {
      this.carousel.style.transition = "none";
      if (this.counter === this.slides_number - 1) {
        this.counter = 1;
        this.thumbnail_counter = 0;
        this.current_thumbnail_page = 0;
        if (this.thumbnail_controller) {
          this.changePage(-this.current_thumbnail_page);
        }
      } else if (this.counter === 0) {
        this.counter = this.slides_number - 2;
        this.thumbnail_counter = this.slides_number - 3;
        this.current_thumbnail_page = 0;
        if (this.thumbnail_controller) {
          this.changePage(this.thumbnails_pages);
        }
      }
      this.shift = -(
        (this.counter * 100) /
        this.slides_number /
        this.slides_in_view
      ).toFixed(2);
      this.moveSlide();
      this.animating = false;
    }, this.animation_speed);
  }

  initialiseConfig(direction, reset) {
    this.counter += direction;
    if (this.thumbnail_controller) {
      this.thumbnail_counter += direction;
      if (this.thumbnail_counter < 0) {
        this.thumbnail_counter = this.slides_number - 3;
      }
      if (
        direction > 0 &&
        this.thumbnail_counter / (this.current_thumbnail_page + 1) >=
          this.thumbnails_in_view
      ) {
        this.changePage(1);
      } else if (
        direction < 0 &&
        this.thumbnail_counter / Math.abs(this.current_thumbnail_page) <
          this.thumbnails_in_view
      ) {
        this.changePage(-1);
      }
    }
    this.shift =
      (
        -(this.counter * 100) /
        this.slides_number /
        this.slides_in_view
      ).toFixed(2) * 1;
    if (!reset) {
      this.carousel.style.transition = `transform ${
        this.animation_speed / 1000
      }s`;
    }
    this.animating = true;
  }

  setActive() {
    this.slides.forEach((slide, index) => {
      if (index === this.counter) {
        slide.classList.add("active");
      } else if (slide.classList.contains("active")) {
        slide.classList.remove("active");
      }
    });
    if (this.thumbnail_controller) {
      const thumbnail_array = Array.from(this.thumbnail_container.children);
      thumbnail_array.forEach((thumb, index) => {
        if (index === this.thumbnail_counter) {
          thumb.classList.add("active");
        } else if (thumb.classList.contains("active")) {
          thumb.classList.remove("active");
        }
      });
    }
  }

  moveSlide() {
    const slides_shifted = this.counter * this.slide_dimension_value;
    const shifted_value =
      slides_shifted +
      (this.carousel_container.offsetWidth % this.slide_dimension_value);
    if (
      this.carousel_width >
      this.carousel_container.offsetWidth + slides_shifted
    ) {
      if (shifted_value < 0) {
        this.carousel.style.transform = `translateX(0px)`;
        this.counter = 0;
        this.thumbnail_counter = 0;
      } else {
        if (!this.fixed_width) {
          this.carousel.style.transform = `translateX(${this.shift}%)`;
        } else {
          this.carousel.style.transform = `translateX(${-slides_shifted}px)`;
        }
      }
    } else if (
      this.carousel_width <=
      shifted_value + this.carousel_container.offsetWidth
    ) {
      this.carousel.style.transform = `translateX(${
        -this.carousel_width + this.carousel_container.offsetWidth
      }px)`;
      this.counter = this.slides_number - this.slides_in_view;
      this.thumbnail_counter = this.slides_number - this.slides_in_view - 2;
      if (this.thumbnail_counter < 0) {
        this.thumbnail_counter = 0;
      }
    } else {
      this.carousel.style.transform = `translateX(${
        -slides_shifted +
        (this.carousel_container.offsetWidth % this.slide_dimension_value)
      }px)`;
    }
    this.setActive();
  }
}

customElements.define("custom-carousel", CustomCarousel);
